<script setup lang="ts">
const links = {
  home: {
    url: 'https://zarinpal.com/',
    text: 'صفحه اصلی',
  },
  contact: {
    url: 'https://www.zarinpal.com/contact.html',
    text: 'تماس با ما',
  },
  about: {
    url: 'https://www.zarinpal.com/aboutus.html',
    text: 'درباره ما',
  },
};
</script>

<template>
  <footer dir="rtl" class="footer p-absolute d-flex justify-center w-100">
    <a :href="links.home.url" class="footer-link text-medium text-b16 color-divider">{{ links.home.text }}</a>
    <div class="vertical-divider"></div>
    <a :href="links.contact.url" class="footer-link text-medium text-b16 color-divider">{{ links.contact.text }}</a>
    <div class="vertical-divider"></div>
    <a :href="links.about.url" class="footer-link text-medium text-b16 color-divider">{{ links.about.text }}</a>
  </footer>
</template>

<style scoped lang="scss">
@import url('./ErrorFooter.scss');
</style>
